import React from "react";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import MultipleStopIcon from "@mui/icons-material/MultipleStop";

const ExportExcelJSButton = ({ currentRows, dataFetch }) => {
  const exportToExcel = async () => {
    // 1. Create a new workbook
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(
      "Manga College of Nursing Scieces Students",
    );

    // 2. Define columns
    // 2. Define columns
    worksheet.columns = [
      { header: "S/N", key: "sn", width: 5 },
      { header: "Student Name", key: "name", width: 35 },
      { header: "Admission No.", key: "admissionNo", width: 25 },
      { header: "Gender", key: "gender", width: 15 },
      { header: "Department", key: "department", width: 35 },
      { header: "Phone Number", key: "phone", width: 20 },
      { header: "State", key: "state", width: 10 },
      { header: "Course", key: "course", width: 20 },
    ];

    // 3. Add rows
    // 3. Add rows
    currentRows.forEach((student, index) => {
      worksheet.addRow({
        sn: index + 1,
        name: (
          student.personalInfo?.first_Name +
          " " +
          student.personalInfo?.sur_Name +
          " " +
          student.personalInfo?.other_Name
        ).toUpperCase(),
        admissionNo:
          student.academicInfo?.admission_number || student.admission_number,
        gender: student.personalInfo?.gender,
        department: student.academicInfo?.department,
        phone: "+234" + student.contactInfo?.phone_number,
        state:
          student.personalInfo?.permanent_home_address?.State_of_origin || "-",
        course: student.academicInfo?.course_of_study || "-",
      });
    });

    // 4. Style header
    worksheet.getRow(1).eachCell((cell) => {
      cell.font = {
        name: "Times New Roman", // exact font
        family: 2, // optional: 2 = roman/serif
        bold: true,
        color: { argb: "FFFFFFFF" },
      };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FF007BFF" },
      };
      cell.alignment = { vertical: "middle", horizontal: "center" };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });

    // 5. Style data cells (optional)
    worksheet.eachRow((row, rowNumber) => {
      if (rowNumber !== 1) {
        // skip header
        row.eachCell((cell) => {
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        });
      }
    });

    // 6. Export
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: "application/octet-stream" });
    saveAs(blob, "Manga College of Nursing Sciences Students List.xlsx");
  };

  return (
    <button
      className="btnExport fx-ac spacem"
      onClick={exportToExcel}
      style={{ display: "inline-flex", alignItems: "center", gap: "5px" }}
    >
      <MultipleStopIcon
        fontSize="large"
        style={{ transform: "rotate(90deg)" }}
      />
      <span>Export Excel</span>
    </button>
  );
};

export default ExportExcelJSButton;
